import React from 'react';

const ExternalLinkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5 4C14.9477 4 14.5 3.55228 14.5 3C14.5 2.44772 14.9477 2 15.5 2H21.5C22.0523 2 22.5 2.44772 22.5 3V9C22.5 9.55228 22.0523 10 21.5 10C20.9477 10 20.5 9.55228 20.5 9V5.41421L11.2071 14.7071C10.8166 15.0976 10.1834 15.0976 9.79289 14.7071C9.40237 14.3166 9.40237 13.6834 9.79289 13.2929L19.0858 4H15.5ZM5.5 7C5.23478 7 4.98043 7.10536 4.79289 7.29289C4.60536 7.48043 4.5 7.73478 4.5 8V19C4.5 19.2652 4.60536 19.5196 4.79289 19.7071C4.98043 19.8946 5.23478 20 5.5 20H16.5C16.7652 20 17.0196 19.8946 17.2071 19.7071C17.3946 19.5196 17.5 19.2652 17.5 19V13C17.5 12.4477 17.9477 12 18.5 12C19.0523 12 19.5 12.4477 19.5 13V19C19.5 19.7957 19.1839 20.5587 18.6213 21.1213C18.0587 21.6839 17.2957 22 16.5 22H5.5C4.70435 22 3.94129 21.6839 3.37868 21.1213C2.81607 20.5587 2.5 19.7957 2.5 19V8C2.5 7.20435 2.81607 6.44129 3.37868 5.87868C3.94129 5.31607 4.70435 5 5.5 5H11.5C12.0523 5 12.5 5.44772 12.5 6C12.5 6.55228 12.0523 7 11.5 7H5.5Z"
      fill="currentColor"
    />
  </svg>
);

export default ExternalLinkIcon;
